import { useDepositDialog } from './logic/useDepositDialog'
import { DepositView } from './views/DepositView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { DialogContentContainerProps } from '@/features/dialogs/common/types'
import { SuccessView } from '@/features/dialogs/common/views/SuccessView'
import { withSuspense } from '@/ui/utils/withSuspense'

function DepositDialogContentContainer({ token, closeDialog }: DialogContentContainerProps) {
  const {
    depositableAssets,
    assetsToDepositFields,
    pageStatus,
    form,
    tokenToDeposit,
    currentPositionOverview,
    updatedPositionOverview,
    relatedCampaigns,
    actionsViewState,
  } = useDepositDialog({
    initialToken: token,
  })

  if (pageStatus.state === 'success') {
    return (
      <SuccessView
        objectiveType="deposit"
        tokenWithValue={tokenToDeposit}
        onProceed={closeDialog}
        proceedText="View in portfolio"
      />
    )
  }

  return (
    <DepositView
      initialToken={token}
      depositAsset={tokenToDeposit.token}
      selectableAssets={depositableAssets}
      actionsViewState={actionsViewState}
      form={form}
      assetsFields={assetsToDepositFields}
      currentPositionOverview={currentPositionOverview}
      updatedPositionOverview={updatedPositionOverview}
      relatedCampaigns={relatedCampaigns}
    />
  )
}

const DepositDialogContentContainerWithSuspense = withSuspense(DepositDialogContentContainer, DialogContentSkeleton)
export { DepositDialogContentContainerWithSuspense as DepositDialogContentContainer }
